import { Linking, Platform } from 'react-native';

/** Open a store listing. Web uses a new tab so the landing page stays put. */
export function openStoreUrl(url: string): void {
  if (Platform.OS === 'web') {
    const g = globalThis as { open?: (href: string, target: string, features: string) => void };
    g.open?.(url, '_blank', 'noopener,noreferrer');
    return;
  }
  void Linking.openURL(url);
}
